import { StreamsData } from "@ts/data/StreamsData";
import { simpleForm } from "../core/SimpleForm";
import { Utils } from "../core/Utils";
import { AbstractSection } from "./AbstractSection";

export class SpotifySection extends AbstractSection {

    public constructor(section:StreamsData) {
        super(section);
        this.renderTarget.classList.add('spotify-wrapper');
    }

    protected onViewRender(): void {
        const data = this.data as StreamsData;
        this.renderTarget.innerHTML = Utils.minify(`
                <iframe id="spotify-src" 
                    src="https://open.spotify.com/embed/${data.sharedcode}" 
                    title="${data.comment}" 
                    class="spotify-wrapper ${(data.shadow ?' shadow':'')}"  
                    allowFullscreen="true">
                </iframe>
            <figcaption id="spotify-comment" class="comment">${data.comment}</figcaption>
        `);
    }
    protected onEditRender(): void {

        const data = this.data as StreamsData;
        this.renderTarget.innerHTML = Utils.minify(`
                <iframe 
                    src="https://open.spotify.com/embed/${data.sharedcode}" 
                    title="${data.comment}" 
                    class="spotify-wrapper ${(data.shadow?' shadow':'')}" 
                    allowFullscreen="true">
                </iframe>
            <figcaption id="spotify-comment" class="comment">${data.comment}</figcaption>
        `);

        if (this.tbar) {
            this.tbar.add('Spotifydelning',
                'Här kan du klistra in en delning från Spotity för att byta ut den Spotifylåt som nu visas',
                'spotify', async () => {
                    await simpleForm('Spotify', 4, 'Klistra delning här', '', 'Spotify delning')
                        .then((share: string) => {
                            const p1 = share.split('/');
                            const type = p1[3];
                            const url = p1[4].split('?')[0];
                            const iframe = this.renderTarget.querySelector('iframe') as HTMLIFrameElement;
                            iframe.src = `https://open.spotify.com/embed/${type}/${url}`;
                            Utils.forceRefresh(iframe);
                        });
                });
            this.tbar.add('Ändra kommentar',
                `Här kan du lägga till en kommentar. Vill du ingen ha så lämna skrivfältet tomt. Kommentaren
                kan vara fler än en rad om du så vill`,
                'comment', async () => {
                    const commentElement = this.renderTarget.querySelector('figcaption') as HTMLElement;
                    await simpleForm('Audio', 4, 'Redigera kommentar', commentElement.innerText, 'Min kommentar')
                        .then((text: string) => {
                            commentElement.innerText = text;
                            Utils.forceRefresh(commentElement);
                        });
                });
            this.tbar.add('Skugga',
                `Växla mellan skugga eller ingen skugga`,
                `shadow`, () => {
                    const iframe = this.renderTarget.querySelector('iframe') as HTMLIFrameElement;
                    if (iframe) {
                        Utils.toggleCss(iframe,'shadow');
                        Utils.forceRefresh(iframe);
                    }

                }
            );

        }
    }

    // https://open.spotify.com/embed/track/7dUmZTebut3NTNXdf3sESB

    // split https://open.spotify.com/
    // [0] https://open.spotify.com/
    // [1] track/7dUmZTebut3NTNXdf3sESB?si=597a63e7cc2247e4

    // split [1] /
    // [0] embed 
    // [1] track (TYPE)
    // [2] 7dUmZTebut3NTNXdf3sESB (URL)

    // if URL contains ?
    // split [2] ? 
    // [0] 7dUmZTebut3NTNXdf3sESB (URL)
    // [1] si=597a63e7cc2247e4

    protected parseContent(): void {
        const iframe = this.renderTarget.querySelector('iframe') as HTMLIFrameElement;
        const p1 = iframe.src.split('https://open.spotify.com/');

        const p2 = p1[1].split('/');
        const type = p2[1];
        let url = p2[2];

        if (url.includes('?')) {
            const p3 = p2[1].split('?');
            url = p3[0];
        }
        const sharedcode = type + '/' + url;
        (this.data as StreamsData).sharedcode = sharedcode;

        (this.data as StreamsData).shadow = iframe.classList.contains('shadow');

        const div = this.renderTarget.querySelector('figcaption') as HTMLElement;
        (this.data as StreamsData).comment = div.innerText;
    }

}